import Vue from 'vue'
import App from './App.vue'
import router from './routers'
import store from './stores'
import './service-worker'
import Plugin from './plugins'
import Directive from './directive'
import AppComponent from './app/components'
import AppMixin from './app/mixin'
import VueGoodTablePlugin from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'
import VTooltip from 'v-tooltip'
import Select2 from 'v-select2-component';
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import VueTabs from 'vue-nav-tabs'
import 'animate.css'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueFloatLabel from "vue-float-label";
import VueClientTable from 'vue-client-table/dist/vue-client-table.min';
import StarRating from 'vue-star-rating'
import VueCryptojs from 'vue-cryptojs'
import io from "socket.io-client";

window.moment = require('moment');
library.add(faUserSecret,fas)
// directive init
Directive(Vue);

// plugin init
Plugin(Vue);

// global app component
AppComponent(Vue);

// add global mixin
AppMixin(Vue);

// init config vendor module
//Config.i18nAutoLoad(Vue, {router: router});

// App init
Vue.config.performance = process.env.NODE_ENV !== 'production';
Vue.config.productionTip = false;
Vue.config.devtools=false;

Vue.config.errorHandler = (err, vm, info) => {
};
Vue.config.warnHandler = function (msg, vm, trace) {
}

const RootApp = new Vue({
    router,
    store,
    VueGoodTablePlugin,
    VTooltip,
    Select2,
    Datetime,
    VueTabs,
    FontAwesomeIcon,
    VueFloatLabel,
    VueClientTable,
    StarRating,
    VueCryptojs,
    data: () => ({}),
    created(){
        AOS.init({
            once: true
        });
    },
    render: h => h(App)
}).$mount('#app');

//hook css to head
const addLink = function(url){
    var link = document.createElement('link');
    link.href = url;
    link.rel = 'stylesheet';
    link.type = 'text/css'; // no need for HTML5
    let a = document.getElementsByTagName('head')[0].appendChild(link); // for IE6
};

setTimeout(()=>{
    addLink('/icons/icons.css');
});

export default RootApp
